import React from 'react';
import { Alert, Card, Col, Row } from 'react-bootstrap';
import { formatCurrency } from '../utils';

export default function ResultadoSimulacao(props) {
  var resultado = props.resultado;
  if (!resultado) return null;

  var mostrarUltima =
    resultado.valorUltimaParcela > 0 &&
    resultado.valorUltimaParcela !== resultado.valorParcela;

  return (
    <Card className="mb-2 border-success">
      <Card.Body className="py-2">
        <h6 className="mb-2 text-success">
          <strong>Resultado da Simulação</strong>
        </h6>

        {resultado.entradaAlterada && (
          <Alert variant="warning" className="py-1 mb-2">
            <small>
              A entrada foi alterada para R${' '}
              {formatCurrency(resultado.entrada)} para corrigir a quantidade de
              parcelas.
            </small>
          </Alert>
        )}

        <Row className="text-center d-none d-md-flex">
          <Col>
            <small className="text-muted d-block">Entrada</small>
            <strong>R$ {formatCurrency(resultado.entrada)}</strong>
          </Col>
          <Col>
            <small className="text-muted d-block">Qtd. Parcelas</small>
            <strong>{resultado.qtdParcelas}</strong>
          </Col>
          <Col>
            <small className="text-muted d-block">
              {resultado.isSAC ? 'Valor 1ª Parcela' : 'Valor da Parcela'}
            </small>
            <strong>R$ {formatCurrency(resultado.valorParcela)}</strong>
          </Col>
          <Col>
            <small className="text-muted d-block">Saldo Financiado</small>
            <strong>R$ {formatCurrency(resultado.saldoFinanciar)}</strong>
          </Col>
          {mostrarUltima && (
            <Col>
              <small className="text-muted d-block">Última Parcela</small>
              <strong>
                R$ {formatCurrency(resultado.valorUltimaParcela)}
              </strong>
            </Col>
          )}
        </Row>

        <div className="d-block d-md-none">
          <Row>
            <Col xs={6}>
              <small className="text-muted d-block">Entrada</small>
              <strong>R$ {formatCurrency(resultado.entrada)}</strong>
            </Col>
            <Col xs={6}>
              <small className="text-muted d-block">Qtd. Parcelas</small>
              <strong>{resultado.qtdParcelas}</strong>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={6}>
              <small className="text-muted d-block">
                {resultado.isSAC ? 'Valor 1ª Parc.' : 'Valor da Parc.'}
              </small>
              <strong>R$ {formatCurrency(resultado.valorParcela)}</strong>
            </Col>
            <Col xs={6}>
              <small className="text-muted d-block">Saldo Financ.</small>
              <strong>R$ {formatCurrency(resultado.saldoFinanciar)}</strong>
            </Col>
          </Row>
          {mostrarUltima && (
            <Row className="mt-2">
              <Col xs={12}>
                <small className="text-muted d-block">Última Parcela</small>
                <strong>
                  R$ {formatCurrency(resultado.valorUltimaParcela)}
                </strong>
              </Col>
            </Row>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}
